import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[70vh] grid place-items-center px-5">
      <div className="max-w-md w-full text-center rounded-2xl border border-[#E4E7EC] bg-white p-10">
        <XCircle className="mx-auto text-[#F79009]" size={56} />
        <h1 className="font-heading text-xl font-bold mt-4 text-[#101828]">Checkout cancelled</h1>
        <p className="text-muted-foreground mt-2 text-sm">No charge was made. Your bundle is saved — you can complete payment anytime.</p>
        <div className="mt-6 flex flex-col gap-2">
          <Button className="rounded-full bg-[#0D5C75] text-white hover:bg-[#094A5E] hover:text-white" onClick={() => navigate("/book")} data-testid="retry-book-btn">Back to booking</Button>
          <Button variant="ghost" onClick={() => navigate("/dashboard")}>Go to dashboard</Button>
        </div>
      </div>
    </div>
  );
}
